import mime from 'mime'

export function getMimeType(uri: string): string {
  let mimeType = mime.getType(uri)
  if (mimeType === null) {
    if (uri.startsWith('data:')) {
      const mimeTypeMatch = uri.match(/^data:([^;]+);/)
      mimeType = mimeTypeMatch ? mimeTypeMatch[1] : null
    }
  }
  return mimeType ?? 'application/octet-stream'
}
